import { render, staticRenderFns } from "./CheckoutPaymentOrangeMoney.vue?vue&type=template&id=2f117d32&scoped=true&"
import script from "./CheckoutPaymentOrangeMoney.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentOrangeMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f117d32",
  null
  
)

export default component.exports